import * as Blockly from "blockly";
import BlocklyJs from "blockly/javascript";
import { OPACITY_MIN, OPACITY_MAX } from "common/components";
import {
  BlocklyJsOperator,
  initPropertyGetterBlock,
  initPropertySetterBlock,
  initPropertySetterByTimeBlock,
} from "common/blockly";

export const InitOpacityPropertyBlock = (
  components: string[][],
  defaultComponent?: string | undefined,
) => {
  function showEditor(e) {
    e.stopPropagation();
    e.preventDefault();
    Blockly.dialog.component(
      { x: e.x, y: e.y },
      this.getValue(),
      components.length === 0 ? [["パーツ", ""]] : components,
      (value: string) => {
        if (value !== null) {
          this.setValue(value);
        }
      },
    );
  }

  Blockly.Blocks["component_property_getter_opacity"] = {
    init: function () {
      this.jsonInit(
        initPropertyGetterBlock(
          "component_property_getter_opacity",
          "%{BKY_GETTER_OPACITY}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "logic_blocks",
          "Number",
        ),
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
    },
  };
  BlocklyJs["component_property_getter_opacity"] = function (block: Blockly.BlockSvg) {
    const component = block.getField("component_id").getValue().split("_");
    const code =
      component[0] === "" ? "" : `codeGen.getOpacity(${component[0]}-container-${component[1]}")`;
    return [code, BlocklyJsOperator.ORDER_ATOMIC];
  };

  Blockly.Blocks["component_property_setter_opacity"] = {
    init: function () {
      this.jsonInit(
        initPropertySetterBlock(
          "component_property_setter_opacity",
          "%{BKY_SETTER_OPACITY}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "logic_blocks",
          "Number",
        ),
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
      this.setOnChange(() => {
        const inputTarget = this.getInputTargetBlock("value") as Blockly.Block;
        if (inputTarget && inputTarget.getField("NUM")) {
          inputTarget.getField("NUM").setValidator((value: number) => {
            if (value > OPACITY_MAX) {
              return OPACITY_MAX;
            } else if (value < OPACITY_MIN) {
              return OPACITY_MIN;
            } else {
              return value;
            }
          });
        }
      });
    },
  };
  BlocklyJs["component_property_setter_opacity"] = function (block: Blockly.BlockSvg) {
    const component = block.getField("component_id").getValue().split("_");
    const value = BlocklyJs.valueToCode(block, "value", BlocklyJsOperator.ORDER_NONE);
    const code =
      component[0] === ""
        ? ""
        : `codeGen.setOpacity("${component[0]}-container-${component[1]}",${value});\n`;
    return code;
  };

  Blockly.Blocks["component_property_setter_opacity_by_step"] = {
    init: function () {
      this.jsonInit(
        initPropertySetterBlock(
          "component_property_setter_opacity_by_step",
          "%{BKY_SETTER_OPACITY_BY_STEP}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "logic_blocks",
          "Number",
        ),
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
      this.setOnChange(() => {
        const inputTarget = this.getInputTargetBlock("value") as Blockly.Block;
        if (inputTarget && inputTarget.getField("NUM")) {
          inputTarget.getField("NUM").setValidator((value: number) => {
            if (value > OPACITY_MAX) {
              return OPACITY_MAX;
            } else if (value < -OPACITY_MAX) {
              return -OPACITY_MAX;
            } else {
              return value;
            }
          });
        }
      });
    },
  };
  BlocklyJs["component_property_setter_opacity_by_step"] = function (block: Blockly.BlockSvg) {
    const component = block.getField("component_id").getValue().split("_");
    const value = BlocklyJs.valueToCode(block, "value", BlocklyJsOperator.ORDER_NONE);
    const code =
      component[0] === ""
        ? ""
        : `codeGen.setOpacityByStep("${component[0]}-container-${component[1]}", ${value});\n`;
    return code;
  };

  Blockly.Blocks["component_property_setter_opacity_by_time"] = {
    init: function () {
      this.jsonInit(
        initPropertySetterByTimeBlock(
          "component_property_setter_opacity_by_time",
          "%{BKY_SETTER_OPACITY_BY_TIME}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "math_blocks",
          "Number",
        ),
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
      this.setOnChange(() => {
        const inputTarget = this.getInputTargetBlock("value") as Blockly.Block;
        if (inputTarget && inputTarget.getField("NUM")) {
          inputTarget.getField("NUM").setValidator((value: number) => {
            if (value > OPACITY_MAX) {
              return OPACITY_MAX;
            } else if (value < OPACITY_MIN) {
              return OPACITY_MIN;
            } else {
              return value;
            }
          });
        }
      });
    },
  };
  BlocklyJs["component_property_setter_opacity_by_time"] = function (block: Blockly.BlockSvg) {
    const component = block.getField("component_id").getValue().split("_");
    const time = BlocklyJs.valueToCode(block, "time", BlocklyJsOperator.ORDER_NONE);
    const value = BlocklyJs.valueToCode(block, "value", BlocklyJsOperator.ORDER_NONE);
    const code =
      component[0] === ""
        ? ""
        : `await codeGen.setOpacityByTime("${component[0]}-container-${component[1]}", ${time}, ${value});\n`;
    return code;
  };
};
